import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen py-24 px-6 md:px-12 lg:px-24" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Privacy Policy</h1>
          
          <div className="space-y-6 text-foreground/80 leading-relaxed">
            <p className="text-sm text-foreground/60">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
            
            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">1. Titolare del Trattamento</h2>
              <p>
                Il Titolare del trattamento dei dati è <strong>Nancy Ghislotti</strong><br/>
                P.IVA: 04569820162<br/>
                Email: info@chichiinviaggio.com
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">2. Tipologia di Dati Raccolti</h2>
              <p>Raccogliamo le seguenti tipologie di dati personali:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, pagine visitate, durata della visita</li>
                <li><strong>Dati forniti volontariamente:</strong> nome, email (tramite form contatti e newsletter)</li>
                <li><strong>Cookie:</strong> cookie tecnici e di analytics per migliorare l'esperienza utente</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">3. Finalità del Trattamento</h2>
              <p>I dati personali sono trattati per le seguenti finalità:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Rispondere alle richieste di contatto inviate tramite form</li>
                <li>Inviare newsletter e comunicazioni promozionali (previo consenso)</li>
                <li>Analizzare le statistiche di utilizzo del sito web</li>
                <li>Adempiere agli obblighi di legge</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">4. Base Giuridica del Trattamento</h2>
              <p>Il trattamento dei dati personali si basa su:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li><strong>Consenso dell'interessato</strong> (art. 6, par. 1, lett. a GDPR) per newsletter e comunicazioni marketing</li>
                <li><strong>Esecuzione di un contratto</strong> (art. 6, par. 1, lett. b GDPR) per rispondere alle richieste</li>
                <li><strong>Interesse legittimo</strong> (art. 6, par. 1, lett. f GDPR) per analytics e miglioramento del servizio</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">5. Modalità di Trattamento</h2>
              <p>
                I dati personali sono trattati con strumenti automatizzati per il tempo strettamente necessario 
                a conseguire gli scopi per cui sono stati raccolti. Specifiche misure di sicurezza sono osservate 
                per prevenire la perdita dei dati, usi illeciti o non corretti ed accessi non autorizzati.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">6. Periodo di Conservazione</h2>
              <p>I dati personali saranno conservati per:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li><strong>Richieste di contatto:</strong> fino a richiesta completata + 1 anno</li>
                <li><strong>Newsletter:</strong> fino a revoca del consenso</li>
                <li><strong>Dati di navigazione:</strong> massimo 26 mesi (Google Analytics)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">7. Comunicazione e Diffusione</h2>
              <p>
                I dati personali non saranno oggetto di diffusione. Potranno essere comunicati a soggetti terzi 
                solo per finalità strettamente connesse alla gestione del servizio (es. provider hosting, 
                servizi email marketing).
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">8. Diritti dell'Interessato</h2>
              <p>In qualità di interessato, hai i seguenti diritti (artt. 15-22 GDPR):</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li><strong>Diritto di accesso:</strong> ottenere conferma dell'esistenza dei tuoi dati</li>
                <li><strong>Diritto di rettifica:</strong> correggere dati inesatti</li>
                <li><strong>Diritto alla cancellazione:</strong> ottenere la cancellazione dei dati ("diritto all'oblio")</li>
                <li><strong>Diritto di limitazione:</strong> limitare il trattamento dei dati</li>
                <li><strong>Diritto di opposizione:</strong> opporti al trattamento dei dati</li>
                <li><strong>Diritto alla portabilità:</strong> ricevere i dati in formato strutturato</li>
                <li><strong>Diritto di revoca:</strong> revocare il consenso in qualsiasi momento</li>
              </ul>
              <p className="mt-4">
                Per esercitare i tuoi diritti, contattaci all'email: <strong>info@chichiinviaggio.com</strong>
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">9. Diritto di Reclamo</h2>
              <p>
                Hai il diritto di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali:<br/>
                Garante per la protezione dei dati personali<br/>
                Piazza Venezia, 11 - 00187 Roma<br/>
                Tel. +39 06.696771<br/>
                Fax +39 06.69677.3785<br/>
                Email: garante@gpdp.it<br/>
                PEC: protocollo@pec.gpdp.it<br/>
                Web: www.garanteprivacy.it
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-semibold text-foreground mb-4">10. Modifiche alla Privacy Policy</h2>
              <p>
                Questa Privacy Policy può essere modificata nel tempo. Ti invitiamo a consultare periodicamente 
                questa pagina per rimanere aggiornato.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;